import styled from '@emotion/styled';

export default styled.div`
  .patient-recovery__btn {
    background-color: #05B2DC;
    color: #FFF;
    border-radius: 10px;
    font-size: 14px;
    text-transform: none;

    &.Mui-selected,:active,:hover {
      background-color: #05B2DC;
      opacity: 0.7;
    }
  }

  .MuiOutlinedInput-root {
    font-size: 14px;
    border-radius: 10px;
    background: #F0F0F0;
    padding: 5px 10px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;